var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "connect-wallet" },
    [
      _c("KeplrMessageBox"),
      _c("MetamaskMessageBox"),
      _c("WalletConnectMessageBox", {
        attrs: {
          qrImg: _vm.qrImg,
          isQrImgLoading: _vm.isQrImgLoading,
          inviteAddress: _vm.ownerAddress,
        },
        on: { refresh: _vm.onRefresh },
      }),
      _c("ConnectWalletMessageBox", {
        attrs: { inviteAddress: _vm.ownerAddress },
        on: { connectWallet: _vm.toConnectWallet },
      }),
      _c("AcceptInvitationInformationMessageBox", {
        attrs: {
          showMessageBox: _vm.isAcceptInvitationInformationMessageBox,
          inviteAddress: _vm.getUser.address,
        },
        on: {
          "update:showMessageBox": function ($event) {
            _vm.isAcceptInvitationInformationMessageBox = $event
          },
          "update:show-message-box": function ($event) {
            _vm.isAcceptInvitationInformationMessageBox = $event
          },
        },
      }),
      _c("AcceptInvitationMessageBox", {
        attrs: {
          inviteAddress: _vm.ownerAddress,
          showMessageBox: _vm.isAcceptInvitationMessageBox,
        },
        on: {
          confirm: _vm.toAcceptInvitation,
          "update:showMessageBox": function ($event) {
            _vm.isAcceptInvitationMessageBox = $event
          },
          "update:show-message-box": function ($event) {
            _vm.isAcceptInvitationMessageBox = $event
          },
        },
      }),
      _c("AcknowledgementTermsMessageBox", {
        attrs: { showMessageBox: _vm.isAcknowledgementTermsMessageBox },
        on: {
          iAgree: _vm.toiAgree,
          "update:showMessageBox": function ($event) {
            _vm.isAcknowledgementTermsMessageBox = $event
          },
          "update:show-message-box": function ($event) {
            _vm.isAcknowledgementTermsMessageBox = $event
          },
        },
      }),
      _c("ReferralRewardsMessageBox", {
        attrs: {
          showMessageBox: _vm.isReferralRewardsMessageBox,
          isfrom: _vm.isReferralRewardsFrom,
          referralRewardsInviteCode: _vm.referralRewardsInviteCode,
        },
        on: {
          "update:showMessageBox": function ($event) {
            _vm.isReferralRewardsMessageBox = $event
          },
          "update:show-message-box": function ($event) {
            _vm.isReferralRewardsMessageBox = $event
          },
          "update:isfrom": function ($event) {
            _vm.isReferralRewardsFrom = $event
          },
          "update:referralRewardsInviteCode": function ($event) {
            _vm.referralRewardsInviteCode = $event
          },
          "update:referral-rewards-invite-code": function ($event) {
            _vm.referralRewardsInviteCode = $event
          },
        },
      }),
      _vm.getUser.address
        ? _c("div", { staticClass: "login" }, [
            _c("div", { staticClass: "login-info-box flex-align-center" }, [
              _c("div", { staticClass: "info-img" }, [
                _c("img", {
                  attrs: { src: _vm.nftImg, alt: "" },
                  on: { error: _vm.$st.handleImageError },
                }),
              ]),
              _c("span", [
                _vm._v(_vm._s(_vm.$format.captureAddress(_vm.getUser.address))),
              ]),
              _c("i", { staticClass: "icon icon-down-arrow" }),
              _c("ul", [
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "clipboard",
                        rawName: "v-clipboard:copy",
                        value: _vm.getUser.address,
                        expression: "getUser.address",
                        arg: "copy",
                      },
                      {
                        name: "clipboard",
                        rawName: "v-clipboard:success",
                        value: _vm.onCopy,
                        expression: "onCopy",
                        arg: "success",
                      },
                    ],
                  },
                  [
                    _c("i", { staticClass: "icon icon-copy-user" }),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("layout.header.connectWallet.copyAddress")
                        )
                      ),
                    ]),
                  ]
                ),
                _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "a-link",
                      attrs: {
                        href: _vm.toViewOnStarScan(),
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                    [
                      _c("i", { staticClass: "icon icon-starScan" }),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("layout.header.connectWallet.viewOnStarScan")
                          )
                        ),
                      ]),
                    ]
                  ),
                ]),
                _c("li", { on: { click: _vm.logoutConnectWallet } }, [
                  _c("i", { staticClass: "icon icon-sign-out" }),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("layout.header.connectWallet.disconnect"))
                    ),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _c(
            "div",
            { staticClass: "no-login" },
            [
              _c(
                "ButtonCommon",
                {
                  attrs: {
                    type: "marginXBridge",
                    width: "100%",
                    height: "32px",
                  },
                  on: { click: _vm.onOpenConnectWallet },
                },
                [
                  _c("h6", { staticClass: "h6-min" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "layout.header.connectWallet.connectWalletButText"
                          )
                        ) +
                        " "
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }